export default "__VITE_ASSET__wQSifVKV__"